import axios from "axios";
import {reducirHash} from "../Funciones/reducirHash";

export const entregarBonos = async ({cuenta, valorContrato, idContrato, hash, consecutivo}) => {

    let obj = {
        padres: cuenta.padres,
        valor: valorContrato,
        nombre: cuenta.nombre,
        minHash: reducirHash({hash: hash, largo: 10}),
        idContrato: idContrato,
        idUsuario: cuenta.id,
        correo: cuenta.correo,
        consecutivo: consecutivo
    }

    let data = JSON.stringify(obj);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        //url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/4a3fc7f7-06f9-4902-bc1c-d565f4753e6a', //test
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/4a3fc7f7-06f9-4902-bc1c-d565f4753e6a',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    return axios.request(config)


}